import { subscribeRNMessage } from './fromRN'
import { downloadAudioToRN } from './toRN'

/**
 * 对方语音走 RN 原生下载（H5 fetch 受 WKWebView CORS 限制，见 downloadAudio handler）。
 * 按 messageId 配对 RN 回传的 downloadAudioResult，返回纯 base64（失败/超时返回 null）。
 * 多条并发各自配对；同一 messageId 并发调用复用同一 Promise（去重，避免重复下载）。
 */

const DOWNLOAD_TIMEOUT = 30000 // ms：音频下载兜底超时，防 Promise 永久挂起泄漏

interface Pending {
  resolve: (base64: string | null) => void
  timer: ReturnType<typeof setTimeout>
}

const pending = new Map<string, Pending>()
let listenerInstalled = false

/** 全局注册一次 downloadAudioResult 监听：到达时按 messageId resolve 对应 Promise */
function ensureListener(): void {
  if (listenerInstalled) return
  listenerInstalled = true
  subscribeRNMessage('downloadAudioResult', (msg) => {
    const p = pending.get(msg.messageId)
    if (!p) return // 已超时清理或非本次请求，忽略
    clearTimeout(p.timer)
    pending.delete(msg.messageId)
    p.resolve(msg.success && msg.data ? msg.data.audioBase64 : null)
  })
}

/** 请求 RN 下载对方语音，返回纯 base64；失败或超时返回 null */
export function downloadAudioViaRN(messageId: string, audioUrl: string): Promise<string | null> {
  ensureListener()
  return new Promise<string | null>((resolve) => {
    const timer = setTimeout(() => {
      pending.delete(messageId)
      resolve(null) // 超时按失败处理，上层标记 DownloadFailed
    }, DOWNLOAD_TIMEOUT)
    pending.set(messageId, { resolve, timer })
    downloadAudioToRN(messageId, audioUrl)
  })
}
